module.exports = __webpack_public_path__ + "img/downloads_ies-cov.b6af3e80.png";